








































import { createComponent } from "@vue/composition-api";
import {
  ingredientGroupResource,
  komponentResource,
  rodzajKomponentuResource,
} from "@megarax/client/src/resources/plm";
import { Ingredient } from "@megarax/client/src/resources/plm/Ingredient";
import BaseForm from "@/components/BaseForm.vue";

interface Props {
  value: Ingredient;
  errors: any;
}

export default createComponent<Props>({
  components: { BaseForm },
  props: {
    value: { required: true, type: Object },
    errors: { default: () => ({}) },
  },
  setup(props, ctx) {
    return {
      komponentResource,
      ingredientGroupResource,
      rodzajKomponentuResource,
    };
  },
});
